export enum KpiType {
  BrandName = 'brand_name',
  BrandOwnerName = 'brand_owner_name',
  Revenue = 'revenue',
  Units = 'units',
  Plk = 'plk',
  ShareRevenue = 'share_revenue',
  ShareUnits = 'share_units',
  SharePlk = 'share_plk',
  ChangeRevenue = 'change_revenue',
  ChangeUnits = 'change_units',
  ChangePlk = 'change_plk',
  AveragePrice = 'average_price',
  AveragePricePlk = 'average_price_plk',
  Distribution = 'distribution',
  NumericDistribution = 'numeric_distribution',
  WeightedDistribution = 'weighted_distribution',
  PriceIndex = 'price_index',
  PriceIndexPlk = 'price_index_plk',
  ChangePriceIndex = 'change_price_index',
  ChangePriceIndexPlk = 'change_price_index_plk',
  FirstActivity = 'first_activity',
  ChangeShareRevenue = 'change_share_revenue',
  ChangeShareUnits = 'change_share_units',
  ChangeSharePlk = 'change_share_plk',
  ChangeAveragePrice = 'change_average_price',
  ChangeAveragePricePlk = 'change_average_price_plk',
  AverageUnitsPerShop = 'average_units_per_shop',
  AveragePlkPerShop = 'average_plk_per_shop',
  InShopShare = 'in_shop_share',
  InShopSharePlk = 'in_shop_share_plk',
  SellingShops = 'selling_shops',
  AverageRevenuePerShop = 'average_revenue_per_shop',
  TurnoverShareRevenue = 'turnover_share_revenue',
  DiffItemSelling = 'diff_item_selling',
  DiffItemSellingPerShop = 'diff_item_selling_per_shop',
  WeightedOfferShare = 'weighted_offer_share',
}

const AllKpiValues = Object.values(KpiType);
export const MoBillboardKpis = AllKpiValues as readonly KpiType[];
export const MoHeatmapKpis = AllKpiValues as readonly KpiType[];
export const ScKpis = AllKpiValues as readonly KpiType[];
